module.exports = __webpack_public_path__ + "static/media/player-sketch.abcd322a.png";